import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { 
  StyledWideBody,
  StyledH3,
  StyledLabel
} from "../../assets/styles/templates/ParticipantSubmissionStyling";
import { RowHead } from "../../assets/styles/atoms/RowHeadStyling";
import { RowBody } from "../../assets/styles/atoms/RowBodyStyling";
import { CardForm } from "../../assets/styles/atoms/CardStyling";
import { ErrorSpan } from "../../assets/styles/atoms/SpanStyling";
import Input from "../atoms/Input";
import {
  fetchAllSubmissions,
  submitProject,
} from "../../store/projectSubmission/actions";
import ProjectTitle from "../organisms/PSProjectTitle";
import ProjectWriteUp from "../organisms/PSProjectWriteUp";
const defaultState = {
  project_title: "",
  participant_or_team_name: "",
  git_url: "",
  video_url: "",
  project_writeups: ""
};
const ParticipantSubmission = ({ initialState = defaultState }) => {
  const { id } = useParams();
  const event_id = Number(id);
  const dispatch = useDispatch();
  const history = useHistory();
  const currentEvent = useSelector(state =>
    state.events.data.find(e => e.id === event_id)
  );
  useEffect(() => {
    dispatch(fetchAllSubmissions(event_id));
  }, [dispatch, event_id]);
  const handleSubmit = values => {
    dispatch(submitProject({ ...values, event_id }, history));
  };
  const requireGithubUrl = currentEvent.requirements.includes("github_url");
  const requireVideoUrl = currentEvent.requirements.includes("video_url");
  const schema = Yup.object().shape({
    project_title: Yup.string()
      .min(3, "Project title must be at least 3 characters long.")
      .required("Project title is required."),
    participant_or_team_name: Yup.string()
      .min(2, "Team/participants name must be at least 2 characters long.")
      .required("Team/participants name is required."),
    git_url: requireGithubUrl
      ? Yup.string()
          .min(8, "GitHub URL must be at least 8 characters long.")
          .required("GitHub URL is required.")
      : Yup.string(),
    video_url: requireVideoUrl
      ? Yup.string()
          .min(8, "Video URL must be at least 8 characters long.")
          .required("Video URL is required.")
      : Yup.string(),
    project_writeups: Yup.string()
      .min(8, "Project writeup must be at least 8 characters long.")
      .required("Project writeup is required.")
  });
  return (
    <StyledWideBody>
      <CardForm>
        <RowHead>
          <StyledH3>Submit Project</StyledH3>
        </RowHead>
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialState}
          validationSchema={schema}
          enableReinitialize
        >
          {() => (
            <Form>
              <ProjectTitle currentEvent={currentEvent} />
              {requireGithubUrl && (
                <RowBody justify="start">
                  <StyledLabel htmlFor="git_url">GitHub URL</StyledLabel>
                  <Input
                    type="text"
                    name="git_url"
                    id="git_url"
                    display="wide"
                  />
                  <ErrorSpan>
                    <ErrorMessage name="git_url" component="div" />
                  </ErrorSpan>
                </RowBody>
              )}
              {requireVideoUrl && (
                <RowBody justify="start">
                  <StyledLabel htmlFor="video_url">Video URL</StyledLabel>
                  <Input
                    type="text"
                    name="video_url"
                    id="video_url"
                    style={{ width: "100%" }}
                  />
                  <ErrorSpan>
                    <ErrorMessage name="video_url" component="div" />
                  </ErrorSpan>
                </RowBody>
              )}
              <ProjectWriteUp />
            </Form>
          )}
        </Formik>
      </CardForm>
    </StyledWideBody>
  );
};
export default ParticipantSubmission;
